import { render, staticRenderFns } from "./AboutContactForm.vue?vue&type=template&id=4d6d3371&scoped=true&"
import script from "./AboutContactForm.vue?vue&type=script&lang=ts&"
export * from "./AboutContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./AboutContactForm.vue?vue&type=style&index=0&id=4d6d3371&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d3371",
  null
  
)

export default component.exports